var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { navigateTo } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { addAccount } from '@popup/steem/actions/account.actions';
import { AccountCreationType, AccountCreationUtils, } from '@popup/steem/utils/account-creation.utils';
import { Screen } from '@reference-data/screen.enum';
import { PrivateKey } from '@steempro/dsteem';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { CheckboxPanelComponent } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
import FormatUtils from 'src/utils/format.utils';
const SUBSTRING_LENGTH = 15;
const CreateAccountStepTwo = ({ navParams, setErrorMessage, setSuccessMessage, setTitleContainerProperties, addAccount, addToLoadingList, removeFromLoadingList, navigateTo, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const emptyKeys = {
        owner: { public: '', private: '' },
        active: { public: '', private: '' },
        posting: { public: '', private: '' },
        memo: { public: '', private: '' },
    };
    const [masterKey, setMasterKey] = useState('');
    const [generatedKeys, setGeneratedKeys] = useState(emptyKeys);
    const [keysTextVersion, setKeysTextVersion] = useState('');
    const accountName = navParams === null || navParams === void 0 ? void 0 : navParams.newUsername;
    const price = navParams === null || navParams === void 0 ? void 0 : navParams.price;
    const creationType = navParams === null || navParams === void 0 ? void 0 : navParams.creationType;
    const selectedAccount = navParams === null || navParams === void 0 ? void 0 : navParams.usedAccount;
    const [paymentUnderstanding, setPaymentUnderstanding] = useState(false);
    const [safelyCopied, setSafelyCopied] = useState(false);
    const [notPrimaryStorageUnderstanding, setNotPrimaryStorageUnderstanding] = useState(false);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_create_account',
            isBackButtonEnabled: true,
        });
        generateMasterKey();
    }, []);
    useEffect(() => {
        if (masterKey === '') {
            setGeneratedKeys(emptyKeys);
            return;
        }
        const posting = PrivateKey.fromLogin(accountName, masterKey, 'posting');
        const active = PrivateKey.fromLogin(accountName, masterKey, 'active');
        const memo = PrivateKey.fromLogin(accountName, masterKey, 'memo');
        const owner = PrivateKey.fromLogin(accountName, masterKey, 'owner');
        setGeneratedKeys({
            owner: {
                private: owner.toString(),
                public: owner.createPublic().toString(),
            },
            active: {
                private: active.toString(),
                public: active.createPublic().toString(),
            },
            posting: {
                private: posting.toString(),
                public: posting.createPublic().toString(),
            },
            memo: {
                private: memo.toString(),
                public: memo.createPublic().toString(),
            },
        });
    }, [masterKey]);
    useEffect(() => {
        if (masterKey.length) {
            setKeysTextVersion(generateKeysTextVersion());
        }
        else {
            setKeysTextVersion('');
        }
        setNotPrimaryStorageUnderstanding(false);
        setSafelyCopied(false);
    }, [generatedKeys]);
    const generateMasterKey = () => __awaiter(void 0, void 0, void 0, function* () {
        if (accountName.length < 3) {
            setMasterKey('');
            setErrorMessage('html_popup_create_account_username_too_short');
            return;
        }
        if (!AccountCreationUtils.validateUsername(accountName)) {
            setMasterKey('');
            setErrorMessage('html_popup_create_account_account_name_not_valid');
            return;
        }
        if (yield AccountCreationUtils.checkAccountNameAvailable(accountName)) {
            setMasterKey(AccountCreationUtils.generateMasterKey());
        }
        else {
            setMasterKey('');
            setErrorMessage('html_popup_create_account_username_already_used');
        }
    });
    const copyAllKeys = () => {
        navigator.clipboard.writeText(FormatUtils.removeHtmlTags(generateKeysTextVersion()));
        setSuccessMessage('popup_html_copied');
    };
    const generateKeysTextVersion = () => {
        return `
    <span class='username'>Account name: @${accountName}</span><br/>
    <span class="key-name">Master password:</span><br/>
    ${masterKey}<br/>
    -----------------------------------------<br/>
    <span class="key-name">Owner key:</span><br/>
    <span class="key-type">Private</span><br/>
    ${generatedKeys.owner.private}<br/>
    <span class="key-type">Public</span><br/>
    ${generatedKeys.owner.public}<br/>
    -----------------------------------------<br/>
    <span class="key-name">Active key:</span><br/>
    <span class="key-type">Private</span><br/>
    ${generatedKeys.active.private}<br/>
    <span class="key-type">Public</span><br/>
    ${generatedKeys.active.public}<br/>
    -----------------------------------------<br/>
    <span class="key-name">Posting key:</span><br/>
    <span class="key-type">Private</span><br/>
    ${generatedKeys.posting.private}<br/>
    <span class="key-type">Public</span><br/>
    ${generatedKeys.posting.public}<br/>
    -----------------------------------------<br/>
    <span class="key-name">Memo key:</span><br/>
    <span class="key-type">Private</span><br/>
    ${generatedKeys.memo.private}<br/>
    <span class="key-type">Public</span><br/>
    ${generatedKeys.memo.public}`;
    };
    const createAccount = () => __awaiter(void 0, void 0, void 0, function* () {
        if (paymentUnderstanding &&
            safelyCopied &&
            notPrimaryStorageUnderstanding) {
            addToLoadingList('html_popup_creating_account');
            try {
                const result = yield AccountCreationUtils.createAccount(creationType, accountName, selectedAccount.name, selectedAccount.keys.active, AccountCreationUtils.generateAccountAuthorities(generatedKeys), price, generatedKeys);
                if (result) {
                    setSuccessMessage('html_popup_create_account_successful');
                    addAccount(result);
                    navigateTo(Screen.HOME_PAGE, true);
                }
                else {
                    setErrorMessage('html_popup_create_account_failed');
                }
            }
            catch (err) {
                setErrorMessage(err.message);
            }
            finally {
                removeFromLoadingList('html_popup_creating_account');
            }
        }
        else {
            setErrorMessage('html_popup_create_account_need_accept_terms_condition');
            return;
        }
    });
    const getPaymentCheckboxLabel = () => {
        switch (creationType) {
            case AccountCreationType.BUYING:
                return getMessage('html_popup_create_account_buy_method_message', [price.toString(), selectedAccount.name]);
            case AccountCreationType.USING_TICKET:
                return getMessage('html_popup_create_account_claim_account_method_message', [selectedAccount.name]);
        }
    };
    return (React.createElement("div", { className: "create-account-step-two", "data-testid": `${Screen.CREATE_ACCOUNT_PAGE_STEP_TWO}-page` }, keysTextVersion.length > 0 && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "keys-card" },
            React.createElement("div", { className: "key-name" },
                "Account name: @",
                accountName),
            React.createElement("div", { className: "key-name" }, "Master password"),
            React.createElement("div", { className: "key" }, `${masterKey === null || masterKey === void 0 ? void 0 : masterKey.substring(SUBSTRING_LENGTH, 0)}...${masterKey === null || masterKey === void 0 ? void 0 : masterKey.toString().slice(-SUBSTRING_LENGTH)}`)),
        React.createElement("div", { className: "keys-card" },
            React.createElement("div", { className: "key-name" }, "Owner key"),
            React.createElement("div", { className: "key-label" }, "Private"),
            React.createElement("div", { className: "key" }, `${(_a = generatedKeys.owner.private) === null || _a === void 0 ? void 0 : _a.substring(SUBSTRING_LENGTH, 0)}...${(_b = generatedKeys.owner.private) === null || _b === void 0 ? void 0 : _b.toString().slice(-SUBSTRING_LENGTH)}`),
            React.createElement("div", { className: "key-label" }, "Public"),
            React.createElement("div", { className: "key" }, `${(_c = generatedKeys.owner.public) === null || _c === void 0 ? void 0 : _c.substring(SUBSTRING_LENGTH, 0)}...${(_d = generatedKeys.owner.public) === null || _d === void 0 ? void 0 : _d.toString().slice(-SUBSTRING_LENGTH)}`)),
        React.createElement("div", { className: "keys-card" },
            React.createElement("div", { className: "key-name" }, "Active Key"),
            React.createElement("div", { className: "key-label" }, "Private"),
            React.createElement("div", { className: "key" }, `${(_e = generatedKeys.active.private) === null || _e === void 0 ? void 0 : _e.substring(SUBSTRING_LENGTH, 0)}...${(_f = generatedKeys.active.private) === null || _f === void 0 ? void 0 : _f.toString().slice(-SUBSTRING_LENGTH)}`),
            React.createElement("div", { className: "key-label" }, "Public"),
            React.createElement("div", { className: "key" }, `${(_g = generatedKeys.active.public) === null || _g === void 0 ? void 0 : _g.substring(SUBSTRING_LENGTH, 0)}...${(_h = generatedKeys.active.public) === null || _h === void 0 ? void 0 : _h.toString().slice(-SUBSTRING_LENGTH)}`)),
        React.createElement("div", { className: "keys-card" },
            React.createElement("div", { className: "key-name" }, "Posting Key"),
            React.createElement("div", { className: "key-label" }, "Private"),
            React.createElement("div", { className: "key" }, `${(_j = generatedKeys.posting.private) === null || _j === void 0 ? void 0 : _j.substring(SUBSTRING_LENGTH, 0)}...${(_k = generatedKeys.posting.private) === null || _k === void 0 ? void 0 : _k.toString().slice(-SUBSTRING_LENGTH)}`),
            React.createElement("div", { className: "key-label" }, "Public"),
            React.createElement("div", { className: "key" }, `${(_l = generatedKeys.posting.public) === null || _l === void 0 ? void 0 : _l.substring(SUBSTRING_LENGTH, 0)}...${(_m = generatedKeys.posting.public) === null || _m === void 0 ? void 0 : _m.toString().slice(-SUBSTRING_LENGTH)}`)),
        React.createElement("div", { className: "keys-card" },
            React.createElement("div", { className: "key-name" }, "Memo Key"),
            React.createElement("div", { className: "key-label" }, "Private"),
            React.createElement("div", { className: "key" }, `${(_o = generatedKeys.memo.private) === null || _o === void 0 ? void 0 : _o.substring(SUBSTRING_LENGTH, 0)}...${(_p = generatedKeys.memo.private) === null || _p === void 0 ? void 0 : _p.toString().slice(-SUBSTRING_LENGTH)}`),
            React.createElement("div", { className: "key-label" }, "Public"),
            React.createElement("div", { className: "key" }, `${(_q = generatedKeys.memo.public) === null || _q === void 0 ? void 0 : _q.substring(SUBSTRING_LENGTH, 0)}...${(_r = generatedKeys.memo.public) === null || _r === void 0 ? void 0 : _r.toString().slice(-SUBSTRING_LENGTH)}`)),
        React.createElement("div", { className: "agree-section" },
            React.createElement(CheckboxPanelComponent, { title: getPaymentCheckboxLabel(), skipTranslation: true, checked: paymentUnderstanding, onChange: () => {
                    setPaymentUnderstanding(!paymentUnderstanding);
                } }),
            React.createElement(CheckboxPanelComponent, { title: "html_popup_create_account_safely_copied_keys", checked: safelyCopied, onChange: () => {
                    setSafelyCopied(!safelyCopied);
                } }),
            React.createElement(CheckboxPanelComponent, { title: "html_popup_create_account_storage_understanding", checked: notPrimaryStorageUnderstanding, onChange: () => {
                    setNotPrimaryStorageUnderstanding(!notPrimaryStorageUnderstanding);
                } })),
        React.createElement("div", { className: "button-panel" },
            React.createElement(ButtonComponent, { label: "html_popup_copy", onClick: () => copyAllKeys(), type: ButtonType.ALTERNATIVE }),
            React.createElement(ButtonComponent, { label: "html_popup_create", onClick: () => createAccount() }))))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
        accounts: state.steem.accounts,
        navParams: state.navigation.params,
    };
};
const connector = connect(mapStateToProps, {
    setErrorMessage,
    setSuccessMessage,
    setTitleContainerProperties,
    addAccount,
    navigateTo,
    addToLoadingList,
    removeFromLoadingList,
});
export const CreateAccountStepTwoComponent = connector(CreateAccountStepTwo);
